export default {
    getList: {
        getPendList: async function (params) {
            let option = {
                url: '/api/v1/partner/delegations',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminServerAuthorization.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getSiteList: async function (params) {
            let option = {
                url: '/api/v1/partner/dropdowns/delegation',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminServerAuthorization.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        grant: async function (params) {
            let option = {
                url: '/api/v1/partner/delegation',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminServerAuthorization.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        canel: async function (params) {
            let option = {
                url: '/api/v1/partner/delegation/' + params.id,
                type: 'delete',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminServerAuthorization.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        confirm: async function (params) {
            let option = {
                url: '/api/v1/partner/delegation/' + params.id,
                type: 'put',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminServerAuthorization.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    }
}